<template>
  <div class="container-fluid">
    <div class="modal fade" id="registerTermModal" tabindex="-1" style="z-index:2041;" aria-labelledby="registerTermModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="UseTerm" v-html="UseTerm"></div>
          <div class="modal-footer" data-bs-dismiss="modal">
            <button class="btn btn-dark" data-mdb-dismiss="modal">關閉</button>
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar">
      <div class="mx-auto"><a class="navbar-brand">註冊</a></div>
    </nav>
    <div class="row">
      <div class="col col-12 col-md-6 col-xl-3">
        <div class="input-group">
          <span class="Title"><span class="Required">* </span>稱呼方式：</span>
          <input type="text" class="form-control" placeholder="暱稱" v-model="Name">
        </div>
        <div class="form-text Help">店家將會這樣稱呼您，請小於（含）四個字</div>
        <div class="input-group">
          <span class="Title"><span class="Required">* </span>性別：</span>
          <select class="form-control Required" v-model="Gender" placeholder="性別" >
            <option value="男性">男性</option>
            <option value="女性">女性</option>
            <option value="以上皆非">以上皆非</option>
          </select>
        </div>
        <div class="form-text Help">請選擇您的社會性別</div>
        <!-- <div class="input-group">
          <span class="Title">電子信箱：</span>
          <input type="text" class="form-control" placeholder="電子信箱" v-model="Email">
        </div>
        <div class="form-text Help">選填，用於收取店家出餐通知</div>
        <div class="input-group">
          <span class="Title">配送地址：</span>
          <input type="text" class="form-control Required" placeholder="你預定接收外送的地址" v-model="Address">
        </div>
        <div class="form-text Help">選填，有需外送服務再填寫即可</div> -->
        <div class="Phone input-group">
          <span class="Title"><span class="Required">* </span>手機號碼：</span>
          <input type="text" class="form-control" placeholder="店家聯繫您的方式" v-model="phone">
          <button class="btn btn-outline-primary" @click="sendSMSCaptcha()" :disabled="SMS">{{smsText}}</button>
        </div>
        <div class="form-text Help">只支援台灣手機號碼</div>
        <div class="input-group Captcha">
          <input ref="captcha" type="text" class="form-control Captcha Required" placeholder="手機驗證碼" v-model="Captcha" autocomplete="off" >
        </div>
        <div class="form-text CaptchaHelp">請點擊獲取驗證碼，並等待簡訊通知，一天限三次</div>
        <div class="input-group"></div>
        <!-- <div class="input-group">
          <span class="Title"><span class="Required">* </span>密碼：</span>
          <input type="password" class="form-control Required" ref="password" placeholder="請輸入您的密碼" v-model="password" autocomplete="off" >
        </div>
        <div class="form-text Help">建議密碼英數混合，英文區分大小寫</div> -->
        <div class="registerTerm">註冊代表同意<span class="Link" @click="registerTerm()">隱私權政策及使用條款</span></div>
        <div class="registerButton">
          <button class="btn btn-lg btn-primary" @click="Register()">
            <i class="fa-solid fa-address-card"></i>註冊
          </button>
        </div>
      </div>
    </div>
    <div class="row Footer">
      <div class="col">
        <button class="btn" @click="Home()">
          <i class="fas fa-home"></i><br><span>首頁</span>
        </button>
      </div>
      <div class="col">
        <button class="btn" @click="goLogin()">
          <i class="fa-solid fa-right-to-bracket"></i><br><span>登入</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import { Auth } from '@/mixins/Auth'
import { swal } from '@/Service/SweetAlert2'

import { getUseTerm, UserRegister, sendSMS } from '@/Service/APIService'

export default {
  name: "Register",
  mixins: [Auth],
  data() {
    return {
      UseTerm: null,          // 隱私權政策及使用條款
      Name: null,             // 消費者稱呼方式
      Gender: null,           // 消費者性別
      Address: null,          // 消費者配送地址
      phone: null,            // 消費者聯絡方式
      Captcha: null,          // 手機驗證碼
      password: null,         // 消費者密碼
      Email: null,            // 消費者電子信箱
      SMS: false,             // 是否已經發送過簡訊
      smsText: "獲取驗證碼",   // 按鈕文字
      countdown: 31,          // 簡訊冷卻時間   
    }
  },
  methods: {
    /* 開關隱私權政策及使用條款 */
    registerTerm: async function() {
      if (this.$data.UseTerm == null) {
        const response = await getUseTerm()

        this.$data.UseTerm = response.data.data.Content

        $("#registerTermModal").modal('show')
      } else {
        $("#registerTermModal").modal('toggle')
      }
    },
    /* 檢查註冊資料是否填妥 */
    checkRegisterData: function() {
      /* 未輸入名字或大於四個字元 */
      if (this.$data.Name == null || this.$data.Name.length > 4) {
        swal.alertError(Global.MESSAGE.REGISTER.NAME_FORMAT_ERROR)
        return false
      /* 未選擇性別 */
      } else if (this.$data.Gender == null) {
        swal.alertError(Global.MESSAGE.REGISTER.GENDER_NO_SELECT)
        return false
      /* 填寫電子郵件卻超過64個字元 */
      } else if (this.$data.Email && this.$data.Email.length > 64) {
        swal.alertError(Global.MESSAGE.REGISTER.MAIL_ERROR)
        return false
      /* 填寫地址卻超過32個字元 */
      } else if (this.$data.Address && this.$data.Address.length > 32) {
        swal.alertError(Global.MESSAGE.REGISTER.ADDRESS_CHAR_EXCEED)
        return false
      /* 手機號碼格式不正確 */
      } else if (!this.checkPhone(this.$data.phone)) {
        swal.alertError(Global.MESSAGE.REGISTER.PHONE_FORMAT_ERROR)
        return false
      }
      return true
    },
    /* 進行註冊動作 */ 
    Register: async function() {
      if (!this.checkRegisterData()) return false

      this.$data.password = this.$data.Captcha

      const params = {
        Name: this.$data.Name,
        Gender: this.$data.Gender,
        // Email: this.$data.Email,
        // Address: this.$data.Address,
        phone: this.$data.phone,
        Captcha: this.$data.Captcha,
        password: this.$data.password
      }

      const response = await UserRegister(params)

      switch (response.data.Message) {
        case Global.API.REGISTER.CREATED:
          swal.alertSuccess(Global.MESSAGE.REGISTER.REGISTER_SUCCESSED, () => { this.Login(this.$data.phone, this.$data.password) })
          break
        case Global.API.REGISTER.CAPTCHA_ERROR:
          swal.alertError(Global.MESSAGE.REGISTER.CAPTCHA_ERROR)
          break
        default:
          swal.alertErrorText(Global.MESSAGE.REGISTER.REGISTER_FAILED, response.data.ERROR_MESSAGE)
      }
    },
    /* 發送簡訊驗證碼 */
    sendSMSCaptcha: async function() {
      if (this.$data.phone == null) {
        swal.alertError(Global.MESSAGE.REGISTER.PHONE_NULL)
        return false
      }
      if (!this.checkPhone(this.$data.phone)) {
        swal.alertError(Global.MESSAGE.REGISTER.PHONE_FORMAT_ERROR)
        return false
      }
      this.$data.SMS = true

      const params = { phone: this.$data.phone }
      const response = await sendSMS(params)

      this.smsTimer()

      if (response.data.Message == "SMS_COUNT_EXCEED") {
        swal.alertError(Global.MESSAGE.USER.SMS_COUNT_EXCEED)
        return false
      }

      swal.alertInfo("簡訊已發送至" + this.$data.phone, "如收不到簡訊，有可能從電信端已設定屏蔽廣告簡訊的功能，請聯絡您的電信商或請換個號碼註冊。")
    },
    smsTimer: function() {
      this.$data.countdown--
      this.$data.smsText = "等待（" + this.$data.countdown + "）"
      setTimeout(() => {
        if (this.$data.countdown > 0) {
          this.smsTimer()
        } else {
          this.$data.countdown = 31
          this.$data.SMS = false
          this.$data.smsText = "獲取驗證碼"
        }
      }, 1000)
    },
    /* 判斷手機號碼格式是否正確 */
    checkPhone: function(Phone) {
      let phoneRegex = /^09\d{8}$/
      return phoneRegex.test(Phone)
    },
    /* 前往登入頁面 */
    goLogin: function() {
      this.$router.push({ name: `Login` })
    },
    /* 前往首頁頁面 */
    Home: function() {
      this.$router.push({ name: `Home` })
    },
  },
  mounted() {
    const captcha = this.$refs.captcha
    if (captcha) captcha.setAttribute('autocomplete', 'new-password')
    const password = this.$refs.password
    if (password) password.setAttribute('autocomplete', 'new-password')
  },
  unmounted() {
    $("#registerTermModal").modal('hide')
    $('.modal-backdrop').remove()
    $('body').removeClass('modal-open').css('overflow', '')
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  margin: 0px;
  padding: 0px;
  > .modal {
    .modal-dialog {
      .modal-content {
        .UseTerm {
          padding: 20px;
          font-weight: bold;
        }
      }
    }
  }
  > .navbar {
    margin-bottom: 20px;
    padding: 0px 20px;
    height: 8vh;
    background-color: #5599FF;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 900;
    > .mx-auto {
      > .navbar-brand {
        margin: 0px;
        color: #FFFFFF;
      }
    }
  }
  > .row {
    margin: 0px;
    padding: 0px;
    justify-content: center;
    .col {
      > .input-group {
        > .Title {
          text-align: right;
          width: 100px;
          line-height: 38px;
          margin-right: 10px;
          font-weight: bold;
          > .Required {
            font-size: 20px;
            color: #880000;
          }
        }
        > input[type=text] {
          width: 10%;
        }
        > button {
          margin-left: 10px !important;
          border-radius: 0.25rem !important;
        }
      }
      > .Captcha {
        float: right;
        width: 150px;
      }
      > .Help {
        text-align: right;
        font-size: 13px;
        margin-bottom: 20px;
      }
      > .CaptchaHelp {
        float: right;
        text-align: right;
        font-size: 13px;
        width: 100%;
        margin-bottom: 20px;
      }
      > .registerTerm {
        text-align: center;
        font-weight: bold;
        > .Link {
          color: #0066FF;
          text-decoration: underline;
        }
      }
      > .registerButton {
        margin-top: 25px;
        padding-bottom: 85px;
        text-align: center;
        > button {
          font-weight: bold;
          > svg {
            margin-right: 3px;
          }
        }
      }
    }
  }
  > .Footer {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: 70px;
    background-color: #5599FF;
    > .col {
      > .btn {
        border: 0px;
        background-color: #5599FF;
        box-shadow: 0px 0px 0px 0px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: 900;
        > .fas {
          margin-bottom: 3px;
          font-size: 24px;
        }
      }
    }
  }
}
</style>